import DealerPageRepository from 'lib/Repositories/DealerPageRepository';
import DealerPageEntity from 'lib/Entities/DealerPageEntity';
import { NotFoundError, ServerError } from 'lib/CustomErrors';
import config from 'lib/config';

export const NEARBY_DEALERS_LIMIT = 30;

export default class ApiDealerPageRepository extends DealerPageRepository {
  // @param dealerPageUrl <String> to fetch dealer page data for
  // @raise <NotFoundError> if the dealer page is not found
  // @raise <ServerError> if a server error is encountered
  // @return dealerPage <DealerPageEntity> the dealer page
  static async fetchByDealerPageUrl(dealerPageUrl) {
    const requestUrl = new URL(`${config.dealerPagesApiUrl}/${dealerPageUrl}`);
    const queryParams = new URLSearchParams(
      `?nearby_limit=${NEARBY_DEALERS_LIMIT}`
    );

    requestUrl.search = queryParams.toString();

    const response = await global.fetch(requestUrl.toString());
    const { dealer_page: dealerPage } = await response.json();

    switch (response.status) {
      case 404:
        throw new NotFoundError('Dealer page not found');
      case 500:
        throw new ServerError('Server error');
      default:
        return new DealerPageEntity({ ...dealerPage });
    }
  }

  static async fetchListings(remoteDealerId, providerName) {
    const requestUrl = new URL(`${config.coreApiUrl}/search`);
    const params = new URLSearchParams(
      `?remote_dealer_id=${remoteDealerId}&provider_name=${providerName}`
    );

    requestUrl.search = params.toString();

    const response = await global.fetch(requestUrl.toString());

    const { records, total_count: total } = await response.json();

    if (!response.ok) {
      throw new Error('Error fetching listings');
    }

    return { records, total };
  }
}
